import { elementType, string, bool } from 'prop-types';
import { Route } from 'react-router-dom';
import { useRedirect } from './useRedirect';

const SmartRoute = ({ component, render, path, exact }) => {
  const redirect = useRedirect(path);

  if (redirect) {
    return (
      <Route
        path={path}
        render={() => {
          window.location = redirect;
        }}
      />
    );
  }

  return render ? (
    <Route path={path} exact={exact} render={render} />
  ) : (
    <Route component={component} path={path} exact={exact} />
  );
};

SmartRoute.propTypes = {
  component: elementType,
  render: elementType,
  path: string.isRequired,
  exact: bool,
};

export { SmartRoute };
